import { Button, Drawer } from "antd";
import styles from "./SelectMarketingMaterialsDrawer.module.scss";
import MarketingMaterialList from "./selectMaterialsDrawer/MarketingMaterialList";
import { MarketingMaterialTableItem } from "shared/types/marketingMaterials";
import { useFetchMarketingMaterials } from "../hooks/useFetchMarketingMaterials";
import { useDataListURLData } from "shared/components/dataListURL/useDataListURLData";
import { useMemo } from "react";
import { isDeliverablePrint } from "./SelectMarketingMaterialsDrawer.utils";

type Props = {
  isAddVisible: boolean;
  onCloseAdd: () => void;
  onSelectMaterials: (materials: MarketingMaterialTableItem[]) => void;
};
const SelectMarketingMaterialsDrawer = ({
  isAddVisible,
  onCloseAdd,
  onSelectMaterials,
}: Props) => {
  const {
    marketingMaterials,
    isError,
    isLoading: marketingMaterialsLoading,
  } = useFetchMarketingMaterials();
  const printableMaterials = useMemo(
    () => marketingMaterials.filter(material => isDeliverablePrint(material)),
    [marketingMaterials],
  );
  const { data, originalData, isLoading, selectedItems } = useDataListURLData<
    keyof MarketingMaterialTableItem,
    MarketingMaterialTableItem
  >({
    isError,
    isLoading: marketingMaterialsLoading,
    data: printableMaterials,
  });

  return (
    <Drawer
      className={styles.addDrawer}
      title={
        <div>
          <b>Order Prints:</b> Select Marketing Material
        </div>
      }
      visible={isAddVisible}
      closable={true}
      width="calc(100vw - 48px)"
      onClose={onCloseAdd}
      footer={
        <div className={styles.footer}>
          <Button onClick={onCloseAdd}>Cancel</Button>
          <Button
            type="primary"
            onClick={() => onSelectMaterials(selectedItems)}
          >
            Select
          </Button>
        </div>
      }
      bodyStyle={{ backgroundColor: "#F5F5F5" }}
    >
      <MarketingMaterialList
        data={data}
        originalData={originalData}
        isLoading={isLoading}
      />
    </Drawer>
  );
};

export default SelectMarketingMaterialsDrawer;
